(() => {
  const initialize = (root) => {
    if (!root || root.dataset.premiumReady) return;
    root.dataset.premiumReady = 'true';
    const message = root.querySelector('[data-drp-message]');
    const messageCount = root.querySelector('[data-drp-message-count]');
    if (message && messageCount) {
      const updateCount = () => { messageCount.textContent = `${message.value.length}/${message.maxLength}`; };
      message.addEventListener('input', updateCount);
      updateCount();
    }
    root.querySelectorAll('[data-drp-photo]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const photo = root.querySelector(`#${CSS.escape(link.dataset.drpPhoto)}`);
        if (!photo) return;
        event.preventDefault();
        root.querySelectorAll('.drp-photo').forEach((figure) => { figure.hidden = figure !== photo; });
        root.querySelectorAll('[data-drp-photo]').forEach((item) => {
          if (item === link) item.setAttribute('aria-current', 'true');
          else item.removeAttribute('aria-current');
        });
      });
    });
    const panel = root.querySelector('#gift-premium-enquiry');
    if (!panel) return;
    const closeButton = panel.querySelector('[data-drp-close]');
    closeButton.hidden = false;
    panel.hidden = true;
    let returnFocus;
    const links = root.querySelectorAll('[data-drp-enquiry]');
    const open = (trigger) => {
      returnFocus = trigger;
      const branding = trigger?.dataset.drpBranding;
      if (branding) {
        const option = panel.querySelector(`option[data-branding="${CSS.escape(branding)}"]`);
        if (option) option.selected = true;
      }
      panel.hidden = false;
      links.forEach((link) => link.setAttribute('aria-expanded', 'true'));
      panel.scrollIntoView({ block: 'start', behavior: 'instant' });
      const focusTarget = panel.querySelector('[data-drp-form-result]') || panel.querySelector('#GiftPremiumEnquiryQuantity');
      focusTarget?.focus({ preventScroll: true });
    };
    links.forEach((link) => {
      link.setAttribute('aria-expanded', 'false');
      link.setAttribute('aria-controls', panel.id);
      link.addEventListener('click', (event) => { event.preventDefault(); open(link); });
    });
    closeButton.addEventListener('click', () => {
      panel.hidden = true;
      links.forEach((link) => link.setAttribute('aria-expanded', 'false'));
      returnFocus?.focus();
    });
    root.querySelector('[data-drp-purchase]')?.addEventListener('click', () => {
      root.querySelector('.drp-quantity input')?.focus({ preventScroll: true });
    });
    const params = new URLSearchParams(window.location.search);
    if (params.get('contact_posted') === 'true' || panel.querySelector('[data-drp-form-result]') || window.location.hash === '#gift-premium-enquiry') open();
  };
  const start = () => document.querySelectorAll('[data-gift-premium]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('shopify:block:select', (event) => {
    if (event.target.matches('.drp-faq-list details')) event.target.open = true;
  });
})();

